/**
 * API 数据优化配置
 * 用于控制 GetAllLastLocations 等大数据量接口的优化策略
 */

const apiOptimizationConfig = {
  // GetAllLastLocations 接口优化配置
  locationApi: {
    // 是否只获取在线设备
    onlyOnline: true,

    // 是否启用 GZIP 压缩
    enableCompression: true,

    // 不同场景的字段配置
    fieldProfiles: {
      // 最小字段集（用于快速更新）
      minimal: [
        'tracker.sssid',
        'tracker.name',
        'lastLoc.latitude',
        'lastLoc.longitude',
        'lastLoc.online',
        'lastLoc.receivedTime'
      ],

      // 标准字段集（用于一般显示）
      standard: [
        // tracker 字段
        'tracker.sssid',
        'tracker.name',
        'tracker.imei',
        'tracker.typeName',
        'tracker.objectTypeId',
        'tracker.color',
        'tracker.icon',
        'tracker.image',
        'tracker.locked',

        // lastLoc 字段
        'lastLoc.latitude',
        'lastLoc.longitude',
        'lastLoc.speed',
        'lastLoc.direction',
        'lastLoc.address',
        'lastLoc.online',
        'lastLoc.receivedTime',
        'lastLoc.battery',

        // 报警
        'lastAlarm'
      ],

      // 完整字段集（用于详情页面）
      full: [
        // tracker 所有字段
        'tracker.sssid',
        'tracker.name',
        'tracker.imei',
        'tracker.typeName',
        'tracker.objectTypeId',
        'tracker.protocol',
        'tracker.color',
        'tracker.icon',
        'tracker.image',
        'tracker.locked',
        'tracker.carNumber',
        'tracker.dvrInfo',
        'tracker.expTime',

        // lastLoc 所有字段
        'lastLoc.latitude',
        'lastLoc.longitude',
        'lastLoc.speed',
        'lastLoc.direction',
        'lastLoc.address',
        'lastLoc.gpsAvailable',
        'lastLoc.gsmLatitude',
        'lastLoc.gsmLongitude',
        'lastLoc.stationID',
        'lastLoc.online',
        'lastLoc.receivedTime',
        'lastLoc.gpsTime',
        'lastLoc.battery',
        'lastLoc.gsmsignal',
        'lastLoc.eventId',
        'lastLoc.eventName',
        'lastLoc.keyValues',
        'lastLoc.journeyStr',
        'lastLoc.wifi',
        'lastLoc.ble',
        'lastLoc.currentNetwork',

        // 报警信息
        'lastAlarm'
      ],

      // 统计专用（用于仪表板）
      statistics: [
        'tracker.sssid',
        'lastLoc.online',
        'lastLoc.receivedTime',
        'lastAlarm'
      ]
    },

    // 根据页面获取字段配置
    getFieldsByRoute(routePath) {
      const routeFieldMap = {
        '/realTimeMonitor': 'full',
        '/videoMonitor': 'full',
        '/trackPlayback': 'standard',
        '/dashboard': 'statistics',
        '/': 'minimal'
      }

      const profile = routeFieldMap[routePath] || 'standard'
      return this.fieldProfiles[profile]
    },

    // 获取优化参数
    getOptimizedParams(routePath, customOptions = {}) {
      return {
        onlyOnline: customOptions.onlyOnline !== undefined ? customOptions.onlyOnline : this.onlyOnline,
        compress: this.enableCompression,
        fields: customOptions.fields || this.getFieldsByRoute(routePath)
      }
    }
  },

  // 其他 API 的优化配置可以在这里添加
  alarmApi: {
    // ...
  },

  reportApi: {
    // ...
  }
}

export default apiOptimizationConfig